import axios from 'axios';

export default class MavenConfig {
  constructor({ baseURL }) {
    this.baseURL = baseURL;
  }

  async getAiAssistWidgetFlag(brandId) {
    const result = await axios.get(`${this.baseURL}/account/${brandId}/ai-assist-widget-flag`);
    return result.data.status;
  }

  async setAiAssistWidgetFlag(brandId, enabled) {
    const result = await axios.post(`${this.baseURL}/account/${brandId}/ai-assist-widget-flag`, {
      status: enabled,
    });
    return result.data;
  }

  async getServerToServerAuthStatus(brandId) {
    const result = await axios.get(`${this.baseURL}/account/${brandId}/mis-status`);
    return result.data;
  }

  async setServerToServerAuthStatus(brandId, enabled) {
    const result = await axios.post(`${this.baseURL}/account/${brandId}/mis-status`, {
      status: enabled,
    });
    return result.data;
  }

  async getCustomContexts(brandId) {
    const result = await axios.get(`${this.baseURL}/account/${brandId}/custom`);
    // NOTE: The items are currently returned as an object instead of an array
    // change this request to have the server return an array
    return Object.entries(result.data).map((item) => ({ ...item[1], name: item[0] }));
  }

  async createCustomContext(brandId, context) {
    const { name, ...cleanedContext } = context;
    const cleanedName = typeof name === 'string' ? name.trim() : '';
    const result = await axios.post(`${this.baseURL}/account/${brandId}/custom/${cleanedName}`, cleanedContext);
    return result.data;
  }

  async updateCustomContext(brandId, context) {
    const { name, ...cleanedContext } = context;
    const cleanedName = typeof name === 'string' ? name.trim() : '';
    const result = await axios.put(`${this.baseURL}/account/${brandId}/custom/${cleanedName}`, cleanedContext);
    return result.data;
  }

  async deleteCustomContext(brandId, context) {
    return axios.delete(`${this.baseURL}/account/${brandId}/custom/${context.name}`);
  }

  async getAuthSdeStatus(brandId) {
    const result = await axios.get(`${this.baseURL}/account/${brandId}/sde-status`);
    return result.data;
  }

  async updateAuthSdeStatus(brandId, value) {
    const result = await axios.post(`${this.baseURL}/account/${brandId}/sde-status`, {
      status: value,
    });
    return result.data;
  }
}
